import { getLatestMovies } from '@/utils/movie';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeader from '@/components/feature/SectionHeader';

export default function LatestMovies() {
  const list = getLatestMovies(12);
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <SectionHeader
        title="最新上线"
        subtitle="按上线时间倒序，第一时间追最新作品"
        icon="ri-time-line"
        moreTo="/category/movie"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}